import { render, staticRenderFns } from "./IQAnswerSnapshotMeta.vue?vue&type=template&id=4fe03838&scoped=true"
import script from "./IQAnswerSnapshotMeta.vue?vue&type=script&setup=true&lang=js"
export * from "./IQAnswerSnapshotMeta.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQAnswerSnapshotMeta.vue?vue&type=style&index=0&id=4fe03838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe03838",
  null
  
)

export default component.exports